// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"4fada0b3","95":"edd6efd0","283":"98b67e09","308":"b91da29a","355":"27924247","622":"1e50d4e4","824":"2c1ada44"}[chunkId] + ".chunk.js";
};